import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
    return (
        <section id='testimonials' className="testimonials-container">
            <h2>What Our Students Say</h2>
            <div className="testimonials">
                <div className="testimonial">
                    <p>"Studying abroad changed my life! I got a scholarship and made lifelong friends!"</p>
                    <h4>John Doe</h4>
                </div>
                <div className="testimonial">
                    <p>"The best experience of my life. I got a chance to study in London!"</p>
                    <h4>Jane Smith</h4>
                </div>
            </div>
        </section>
    );
}

export default Testimonials;
